import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { CampaignsPage } from './pages/CampaignsPage';
import { CampaignNewPage } from './pages/CampaignNewPage';
import { CampaignDetailPage } from './pages/CampaignDetailPage';
import { CampaignChatsPage } from './pages/CampaignChatsPage';
import { CampaignTargetPage } from './pages/CampaignTargetPage';
import { CampaignDialogsPage } from './pages/CampaignDialogsPage';
import { CampaignPromptsPage } from './pages/CampaignPromptsPage';
import { CampaignAccountsPage } from './pages/CampaignAccountsPage';
import { CampaignTeamPage } from './pages/CampaignTeamPage';
import { CampaignLaunchPage } from './pages/CampaignLaunchPage';
import { CampaignReportsPage } from './pages/CampaignReportsPage';
import { CampaignInboxPage } from './pages/CampaignInboxPage';
import { CampaignChatPage } from './pages/CampaignChatPage';
import { CampaignLogsPage } from './pages/CampaignLogsPage';
import { CampaignHistoryPage } from './pages/CampaignHistoryPage';
import { AccountsPage } from './pages/AccountsPage';
import { AccountDetailPage } from './pages/AccountDetailPage';
import { AccountDialogsPage } from './pages/AccountDialogsPage';
import { AccountLogsPage } from './pages/AccountLogsPage';
import { ProfilePage } from './pages/ProfilePage';

export default function App(): JSX.Element {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<Navigate to="/campaigns" replace />} />
        <Route path="/campaigns" element={<CampaignsPage />} />
        <Route path="/campaigns/new" element={<CampaignNewPage />} />
        <Route path="/campaigns/:id" element={<CampaignDetailPage />} />
        <Route path="/campaigns/:id/chats" element={<CampaignChatsPage />} />
        <Route path="/campaigns/:id/chats/:targetId" element={<CampaignTargetPage />} />
        <Route path="/campaigns/:id/dialogs" element={<CampaignDialogsPage />} />
        <Route path="/campaigns/:id/prompts" element={<CampaignPromptsPage />} />
        <Route path="/campaigns/:id/accounts" element={<CampaignAccountsPage />} />
        <Route path="/campaigns/:id/team" element={<CampaignTeamPage />} />
        <Route path="/campaigns/:id/launch" element={<CampaignLaunchPage />} />
        <Route path="/campaigns/:id/logs" element={<CampaignLogsPage />} />
        <Route path="/campaigns/:id/history" element={<CampaignHistoryPage />} />
        <Route path="/campaigns/:id/reports" element={<CampaignReportsPage />} />
        <Route path="/campaigns/:id/inbox" element={<CampaignInboxPage />} />
        <Route path="/campaigns/:id/inbox/:threadId" element={<CampaignChatPage />} />
        <Route path="/accounts" element={<AccountsPage />} />
        <Route path="/accounts/:id" element={<AccountDetailPage />} />
        <Route path="/accounts/:id/dialogs" element={<AccountDialogsPage />} />
        <Route path="/accounts/:id/logs" element={<AccountLogsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="*" element={<Navigate to="/campaigns" replace />} />
      </Route>
    </Routes>
  );
}
